import React, {useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedBatchIdsSlot, setSelectedBatchIdsSlot } from '../../../reducers/uiSlice';
import { getBatchInfo, getBatchNumber, getBatchOrderArea, getDriverOrderCount, getDistricts, getStaffList, getBlindScanBatch, getMachineConfig, getZoneSlotMapping } from '../../../actions/saActions';
import SelectBatchTable from './SelectBatchTable';
import BlindBatch from './BlindBatch';
import BasicInfo from './BasicInfo';
import SortingZone from './SortingZone';
import { getRefererFromId, getUserPreference } from '../../../utilities/common';
import * as mmHelper from '../../../network/mmHelper';
import { Button, Tooltip} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';
import ArrowRightAltOutlinedIcon from '@material-ui/icons/ArrowRightAltOutlined';
import {MenuItem, Select} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import AllInOneConfigZone from './AllInOneConfigZone';
import moment from 'moment/moment';
import { useToken } from '../../../utilities/hooks';

const useStyles = makeStyles((theme)=> ({
    preInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 40
    },
    select: {
        marginBottom: 20
    },
    buttonSetStyle: {
        position: 'absolute',
        top: '50%',
        left: '47.6%',
        display: 'flex',
        flexDirection: 'column'
    },
    buttonStyle: {
        border: 'solid 1px #ff9800',
        borderRadius: 5,
        padding: '2px 20px',
        marginBottom: 10
    }
}))

const ALL_IN_ONE_MODE = 306;

function SelectBatches(props){
    const classes = useStyles();
    const {t} = useTranslation('common');
    const dispatch = useDispatch();

    let userPref = getUserPreference();
    const tokenContents = useToken();

    const userHasAllInOneMode = tokenContents.uiAbilities.includes(ALL_IN_ONE_MODE);

    const slotManagement = useSelector(state => state.saReducer);
    const selectedBatchIds = useSelector(getSelectedBatchIdsSlot);   

    const [tableSelection, setTableSelection] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);
    const [branch, setBranch] = useState(userPref.userCity);
    const [blindBatch, setBlindBatch] = useState([]);
    const [zoneSlot, setZoneSlot] = useState([]);
    const [batchSelection, setBatchSelection] = useState([]);
    const [machineConfig, setMachineConfig] = useState([]);
    const [timestamp, setTimestamp] = useState(moment(moment().subtract(30, 'days')).unix());

    const handleWarehouseChange = (event) => {
        props.handleWarehouseChange(event.target.value);
        setBranch(event.target.value);
        dispatch(getBatchNumber(event.target.value));
        dispatch(getBlindScanBatch(event.target.value))
        .catch(() => {
            setBlindBatch([]);
        });
        dispatch(getMachineConfig(event.target.value));
        dispatch(getZoneSlotMapping(event.target.value));
    }

    const wizardSteps = [
        {
            step: 1,
            title: t('mapManagement:select_batch_title'),
            disableGoBack: true,
            disableGoNext: tableSelection.length <= 0,
            tooltip: t('mapManagement:select_batch_next_tooltip')
        }
    ]

    const fetchTimestamp = (timestamp) => {
        setTimestamp(moment(timestamp).unix());
    }

    useEffect(() => {
        dispatch(getBatchNumber(branch, timestamp));
    }, [timestamp])

    const allSteps = [
        <SelectBatchTable
            branch={branch}
            batchList={slotManagement.batches}
            isLoading={slotManagement.batchesLoading}
            selectedBatches={selectedBatchIds}
            onTableSelection={handleTableSelection}
            onBatchSelection={handleBatchSelection}
            createSubDisabled={canCreateSubBatch(tableSelection)}
            fetchBatchList={()=>dispatch(getBatchNumber(branch))}
            fetchTimestamp={fetchTimestamp}
        />
    ]

    useEffect(()=> {
        if(selectedBatchIds) {
            if(selectedBatchIds.length > 0 && currentStep === 1){
                setCurrentStep(1)
                //dispatch(getBatchOrderArea(selectedBatchIds))
            }
        }
        
        //When launching wizard and batch list is empty
        if(currentStep === 0 && slotManagement.batches.length <= 0){           
            dispatch(getBatchNumber(branch));
            dispatch(getBlindScanBatch(branch))
            .catch(() => {
                setBlindBatch([]);
            });
            dispatch(getMachineConfig(branch));
            dispatch(getZoneSlotMapping(branch));
        }
    }, [currentStep])

    useEffect(() => {
        if(slotManagement.getBlindScanBatch) {
            setBlindBatch(slotManagement.getBlindScanBatch);
        }
    }, [slotManagement.getBlindScanBatch])

    useEffect(() => {
        if(slotManagement.getMachineConfig) {
            setMachineConfig(slotManagement.getMachineConfig);
        }
    }, [slotManagement.getMachineConfig])

    useEffect(() => {
        if(slotManagement.getZoneSlotMapping) {
            setZoneSlot(slotManagement.getZoneSlotMapping);
        }
    }, [slotManagement.getZoneSlotMapping])
    useEffect(() => {
        dispatch(getBlindScanBatch(branch))
        .catch((err) => {
            setBlindBatch([]);
        })
    }, [])

    return (
        <Fragment>
            <div className={classes.preInfo}>
                <div>
                    <Select
                        className={classes.select}
                        defaultValue={userPref.userCity}
                        displayEmpty
                        variant="outlined"
                        onChange={handleWarehouseChange}
                    >
                        {
                            (props.branches).map((branch, index) => {
                                return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                            })
                        }
                    </Select>
                    <BlindBatch
                        blindBatch={blindBatch}
                        branch={branch}
                    />
                    <SortingZone
                        branch={branch}
                        branches={props.branches}
                        zoneSlot={zoneSlot}
                    />
                    {
                        userHasAllInOneMode &&
                        <AllInOneConfigZone
                            branch={branch}
                        />
                    }
                </div>
                <div>
                    <BasicInfo 
                        batchSelection={batchSelection}
                        branch={branch}
                        branches={props.branches}
                        machineConfig={machineConfig}
                    />
                </div>
            </div>            
            <div style={{width: '100%', height: '600px'}}>
                {getStepContent(currentStep)}
            </div>
            <div className={classes.buttonSetStyle}>
                <Tooltip title={t('slotAssignment:clearBatch')}>
                    <span>
                        <Button onClick={handlePrevStep} className={classes.buttonStyle} color='primary'>
                            <RefreshIcon fontSize='large' />
                        </Button>
                    </span>
                </Tooltip>                
                <Tooltip title={wizardSteps[currentStep].tooltip}>
                    <span>
                        <Button 
                            color='primary' 
                            onClick={handleNextStep} 
                            disabled={wizardSteps[currentStep].disableGoNext}
                            className={classes.buttonStyle}
                            style={wizardSteps[currentStep].disableGoNext ? { borderColor:'rgba(255, 255, 255, 0.3)'} : { borderColor: '#ff9800' }}
                        >
                            <ArrowRightAltOutlinedIcon fontSize='large' />
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </Fragment>
    )

    function getStepContent(step){
        return (
            <>
            {allSteps.map((stepComponent, index) => {
                return <div style={{width: '100%', height: '100%'}} key={`steps-${index}`} hidden={index !== step}>{stepComponent}</div>
            })}
            </>
        )
    }

    function handleBatchSelection(batches) {
        setBatchSelection(batches)
    }

    function canCreateSubBatch(selected){
        return selected.length <= 0 || _.some(getRefererFromId(slotManagement.batches, selected), 'SUB')
    }

    function handleTableSelection(selectedRows){
        setTableSelection(selectedRows);
    }

    function handleNextStep(){
        let nextStep = currentStep + 1
        let ids = getRefererFromId(slotManagement.batches, tableSelection)
        dispatch(getBatchInfo(branch, ids))
        dispatch(getBatchOrderArea(ids))
        dispatch(getDriverOrderCount(branch, ids))
        dispatch(setSelectedBatchIdsSlot(ids))
        
        if(wizardSteps.length > nextStep){
            setCurrentStep(() => nextStep)
        }
    }

    function handlePrevStep(){
        mmHelper.batchChange(dispatch, branch, []);
        dispatch(getBatchNumber(branch, timestamp));
        dispatch(setSelectedBatchIdsSlot());
        //dispatch(getStaffList(branch, 1))
        dispatch(getDistricts());
    }
}

export default SelectBatches